import axios from 'axios'

export const ADMIN_TOKEN_KEY = 'mpanel_token'
export const ADMIN_USER_KEY = 'mpanel_admin'
export const ADMIN_TENANT_KEY = 'mpanel_revenda_tenant'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 60000,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  const revendaTenant = localStorage.getItem(ADMIN_TENANT_KEY)
  if (revendaTenant) {
    config.headers['X-Tenant-ID'] = revendaTenant
  }
  return config
})

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.includes('/admin/login')) {
      localStorage.removeItem(ADMIN_TOKEN_KEY)
      localStorage.removeItem(ADMIN_USER_KEY)
      if (!window.location.pathname.endsWith('/login')) {
        window.location.href = '/m-panel/login'
      }
    }
    return Promise.reject(error)
  }
)

export const adminApi = {
  login: (email, password) => api.post('/admin/login', { email, password }),
  me: () => api.get('/admin/me'),
  stats: () => api.get('/admin/stats'),
  updateProfile: (body) => api.patch('/admin/profile', body),

  listAdmins: () => api.get('/admin/admins'),
  registerAdmin: (body) => api.post('/admin/register', body),
  toggleAdmin: (id) => api.patch(`/admin/admins/${id}/toggle`),
  deleteAdmin: (id) => api.delete(`/admin/admins/${id}`),

  listLoginBlocks: () => api.get('/admin/security/login-blocks'),
  unlockLoginBlock: (id, body) => api.post(`/admin/security/login-blocks/${id}/unlock`, body),

  listTenants: () => api.get('/admin/tenants'),
  createTenant: (body) => api.post('/admin/tenants', body),
  editTenant: (tenantId, body) => api.patch(`/admin/tenants/${tenantId}`, body),
  deleteTenant: (tenantId) => api.delete(`/admin/tenants/${tenantId}`),
  resetPassword: (tenantId) => api.post(`/admin/tenants/${tenantId}/reset-password`),
  toggleTenant: (tenantId, active) =>
    api.patch(`/admin/tenants/${tenantId}/toggle-status`, { active }),
  impersonate: (tenantId) => api.post(`/admin/tenants/${tenantId}/impersonate`),

  listRevendaTenants: () => api.get('/admin/revenda/tenants'),

  listRevendas: () => api.get('/admin/revenda'),
  createRevenda: (body) => api.post('/admin/revenda', body),
  updateRevenda: (id, body) => api.patch(`/admin/revenda/${id}`, body),
  deleteRevenda: (id) => api.delete(`/admin/revenda/${id}`),
  blockRevenda: (id) => api.post(`/admin/revenda/${id}/block`),
  syncRevendaPortal: (id) => api.post(`/admin/revenda/${id}/sync-portal`),

  listNotifications: () => api.get('/admin/notifications'),
  createNotification: (body) => api.post('/admin/notifications', body),
  updateNotification: (id, body) => api.put(`/admin/notifications/${id}`, body),
  deleteNotification: (id) => api.delete(`/admin/notifications/${id}`),

  getMaviSettings: () => api.get('/admin/mavi/settings'),
  saveMaviSettings: (body) => api.put('/admin/mavi/settings', body),
  testMaviConnection: () => api.post('/admin/mavi/settings/test'),
  listMaviFeedback: (params) => api.get('/admin/mavi/feedback', { params }),
  updateMaviFeedback: (id, body) => api.patch(`/admin/mavi/feedback/${id}`, body),

  monitoringCurrent: () => api.get('/admin/monitoring/current'),
  monitoringHistory: () => api.get('/admin/monitoring/history'),
  monitoringTenants: () => api.get('/admin/monitoring/tenants'),
  monitoringLogs: (limit = 60) => api.get('/admin/monitoring/logs', { params: { limit } }),
  monitoringSystem: () => api.get('/admin/monitoring/system'),
  monitoringForceSave: () => api.post('/admin/monitoring/force-save'),

  listPrices: () => api.get('/admin/prices'),
  createPrice: (body) => api.post('/admin/prices', body),
  updatePrice: (id, body) => api.patch(`/admin/prices/${id}`, body),
  deletePrice: (id) => api.delete(`/admin/prices/${id}`),

  billingReport: (params) => api.get('/admin/billing/report', { params }),

  resetParking: () => api.post('/admin/reset-parking'),
}

export function getApiErrorMessage(error, fallback = 'Erro na requisição') {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    fallback
  )
}

export default api
